import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { PredictionTagsComponent } from 'src/app/components/shared/gallery/prediction-tags/prediction-tags.component';
import { ButtonComponent } from 'ui-library';

@Component({
    selector: 'app-tags',
    imports: [
        CommonModule,
        MatToolbarModule,
        TranslateModule,
        PredictionTagsComponent,
        ButtonComponent,
        MatIconModule
    ],
    standalone: true,
    templateUrl: './tags.component.html',
    styleUrl: './tags.component.scss'
})


export class TagsComponent {
    module: string = 'crane';

    constructor() { }
}
